import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentCheckIn on CheckIn {
    title
    prompt
    suggestedResponses
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentCheckInFragment,
  ents.core.summit.CheckIn
>({
  prompt: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  suggestedResponses: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(transformers.PASS_THROUGH, {
      onNullish: 'remove',
    }),
    [],
  ),
  title: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
})
